// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Footer_navbar__jhaJN","nav-link":"Footer_nav-link__3g1Jw","footer":"Footer_footer__1w0lV"};